<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Policy'
}

</script>



// WEBPACK FOOTER //
// src/Crm/containers/Policy.vue